module.exports = __webpack_public_path__ + "static/media/feature_6.021fca3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/feature_6.png
// module id = 1255
// module chunks = 0